'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareFor = exports.deleteDoc = exports.revokeDocShare = exports.shareDoc = exports.revokeFolderShare = exports.shareFolder = exports.deleteFolder = exports.newFolder = exports.pnxToken = exports.revoke = exports.auth = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _network = require('./network');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: implement cache purging for these mutations

var auth = exports.auth = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(email, password, _ref2) {
    var network = _ref2.network;
    var res;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return network.renew(email, password);

          case 2:
            res = _context.sent;
            return _context.abrupt('return', res);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function auth(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// TODO: figure out testing strategy for these mutations
var revoke = exports.revoke = function revoke(_ref3) {
  var session = _ref3.session;

  // setting the token to undefined makes it seem as it was never passed in
  session.me = undefined;

  // remove so future request need to re-authenticate.
  session.store.remove(session.token);

  // token is only used when me is null by network but set it to undefined for
  // good measure
  session.token = undefined;

  // the official ShareBase API doesn't provide a mechanism to revoke tokens so
  // the pnx tokens are still active, just discarded.
  return true;
};

var pnxToken = exports.pnxToken = function () {
  var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref5) {
    var network = _ref5.network,
        me = _ref5.session.me;
    var email, password, pnxToken;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            email = me.email, password = me.password;
            _context2.next = 3;
            return network.getPnxToken(email, password);

          case 3:
            pnxToken = _context2.sent;
            return _context2.abrupt('return', pnxToken);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function pnxToken(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

var newFolder = exports.newFolder = function () {
  var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(libraryId, path, _ref7) {
    var network = _ref7.network;
    var res;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return network.request('libraries/' + libraryId + '/folders', (0, _extends3.default)({
              method: 'POST' }, (0, _network.jsonify)({ "FolderPath": path })));

          case 2:
            res = _context3.sent;
            return _context3.abrupt('return', res);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function newFolder(_x5, _x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();

var deleteFolder = exports.deleteFolder = function () {
  var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(folderId, _ref9) {
    var network = _ref9.network;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return network.request('folders/' + folderId, { method: 'DELETE' });

          case 2:
            return _context4.abrupt('return', true);

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function deleteFolder(_x8, _x9) {
    return _ref8.apply(this, arguments);
  };
}();

var shareFolder = exports.shareFolder = function () {
  var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(folderId, input, context) {
    var resp;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return shareFor('folders/' + folderId + '/share', input, context);

          case 2:
            resp = _context5.sent;
            return _context5.abrupt('return', resp);

          case 4:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function shareFolder(_x10, _x11, _x12) {
    return _ref10.apply(this, arguments);
  };
}();

var revokeFolderShare = exports.revokeFolderShare = function () {
  var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(folderId, shareId, _ref12) {
    var network = _ref12.network;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return network.request('folders/' + folderId + '/share/' + shareId, {
              method: 'DELETE'
            });

          case 2:
            return _context6.abrupt('return', true);

          case 3:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined);
  }));

  return function revokeFolderShare(_x13, _x14, _x15) {
    return _ref11.apply(this, arguments);
  };
}();

var shareDoc = exports.shareDoc = function () {
  var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(documentId, input, context) {
    var resp;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return shareFor('documents/' + documentId + '/share', input, context);

          case 2:
            resp = _context7.sent;
            return _context7.abrupt('return', resp);

          case 4:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function shareDoc(_x16, _x17, _x18) {
    return _ref13.apply(this, arguments);
  };
}();

var revokeDocShare = exports.revokeDocShare = function () {
  var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(documentId, shareId, _ref15) {
    var network = _ref15.network;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return network.request('documents/' + documentId + '/share/' + shareId, {
              method: 'DELETE'
            });

          case 2:
            return _context8.abrupt('return', true);

          case 3:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined);
  }));

  return function revokeDocShare(_x19, _x20, _x21) {
    return _ref14.apply(this, arguments);
  };
}();

var deleteDoc = exports.deleteDoc = function () {
  var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(documentId, _ref17) {
    var network = _ref17.network;
    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return network.result('documents/' + documentId, { method: 'DELETE' });

          case 2:
            return _context9.abrupt('return', true);

          case 3:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, undefined);
  }));

  return function deleteDoc(_x22, _x23) {
    return _ref16.apply(this, arguments);
  };
}();

// Converts data sharing requests udata from our format into a format for the
// official ShareBase API.
var shareFor = exports.shareFor = function () {
  var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(url, input, _ref19) {
    var network = _ref19.network;
    var expiresOn, singleUse, password, allowView, allowDownload, allowUpload, r, resp;
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            expiresOn = input.expiresOn, singleUse = input.singleUse, password = input.password, allowView = input.allowView, allowDownload = input.allowDownload, allowUpload = input.allowUpload;

            if (!(expiresOn !== undefined && singleUse !== undefined)) {
              _context10.next = 3;
              break;
            }

            throw TypeError('expiresOn and singleUse are mutally exclusive. You can only have one' + 'or only the other');

          case 3:
            r = {};

            if (expiresOn !== undefined) {
              // TODO: the format for this might be wrong. The official docs dont document
              // it.
              r['ExpiresOn'] = new Date(expiresOn).toString();
              r['ExpireStyle'] = 'date';
            } else if (singleUse !== undefined) {
              r['ExpireStyle'] = 'singleuse';
            }

            if (password) {
              r['Password'] = password;
            }

            r['AllowView'] = allowView;
            r['AllowDownload'] = allowDownload;
            r['AllowUpload'] = allowUpload;

            // send request and return response
            _context10.next = 11;
            return network.request(url, (0, _extends3.default)({ method: 'POST' }, (0, _network.jsonify)(r)));

          case 11:
            resp = _context10.sent;
            return _context10.abrupt('return', resp);

          case 13:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, undefined);
  }));

  return function shareFor(_x24, _x25, _x26) {
    return _ref18.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./~/nice-sharebase/lib/mutations.js
// module id = 550
// module chunks = 0